import { FC } from 'react'

type DownIconProps = {
  active: boolean
}

const DownIcon: FC<DownIconProps> = ({ active }) => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 5L5.35355 5.35355C5.15829 5.54882 4.84171 5.54882 4.64645 5.35355L5 5ZM8.64645 0.646447C8.84171 0.451185 9.15829 0.451185 9.35355 0.646447C9.54882 0.841709 9.54882 1.15829 9.35355 1.35355L8.64645 0.646447ZM0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447C0.841709 0.451185 1.15829 0.451185 1.35355 0.646447L0.646447 1.35355ZM4.64645 4.64645L8.64645 0.646447L9.35355 1.35355L5.35355 5.35355L4.64645 4.64645ZM1.35355 0.646447L5.35355 4.64645L4.64645 5.35355L0.646447 1.35355L1.35355 0.646447Z"
        fill={active ? '#42494F' : '#8C949C'}
      />
    </svg>
  )
}

export default DownIcon
